<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-More`]" width="1em" height="1em" v-bind="$attrs"><path d="M6 13.5C6.82843 13.5 7.5 12.8284 7.5 12 7.5 11.1716 6.82843 10.5 6 10.5 5.17157 10.5 4.5 11.1716 4.5 12 4.5 12.8284 5.17157 13.5 6 13.5zM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12 13.5 11.1716 12.8284 10.5 12 10.5 11.1716 10.5 10.5 11.1716 10.5 12 10.5 12.8284 11.1716 13.5 12 13.5zM18 13.5C18.8284 13.5 19.5 12.8284 19.5 12 19.5 11.1716 18.8284 10.5 18 10.5 17.1716 10.5 16.5 11.1716 16.5 12 16.5 12.8284 17.1716 13.5 18 13.5z"/></svg>
</template>
<script>

export default {
  name: 'IconMore',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
